import React, { Component } from "react";
import CookieConsent from "react-cookie-consent";
import { Translate, I18n } from "react-redux-i18n";

export default class CookieBanner extends Component {
  render() {
    return (
      <div>
        <CookieConsent
          style={{ background: "#e0eef2", color: "#182026" }}
          buttonStyle={{
            boxShadow: "inset 0 0 0 0 rgba(16, 22, 26, 0.4), inset 0 0 0 rgba(16, 22, 26, 0.2)",
            backgroundColor: "#2D92A8",
            color: "#ffffff"
          }}
          buttonText={I18n.t('i_understand')}
        >
          <Translate value="cookie_banner" />
        </CookieConsent>
      </div>
    );
  }
}
